module.exports = __webpack_public_path__ + "static/media/estfes.0a31ad8f.webp";